import styled from 'styled-components/macro';

import { Heading3 } from 'css/css';

export const MenuText = styled(Heading3)`
  color: white;
`;
